/**
 * Vocabulario dos eventos, compartilhado pelas duas areas.
 *
 * Os VALORES espelham exatamente os `TextChoices` do backend
 * (`photoe/dbmodels/event.py`) e sao sempre em ingles — o rotulo visivel sai do
 * catalogo i18n pela chave `event.category.<valor>`. A MODALIDADE nao e mais
 * uma lista fixa: e cadastro (`/api/sports/`) e chega pronta em `sport_name`.
 */
export const EVENT_CATEGORIES = [
  "sports",
  "corporate",
  "party",
  "wedding",
  "graduation",
  "concert",
  "other",
];

/** Espelha Event.Status do backend. `unlisted` = acessivel por URL, fora das listagens. */
export const EVENT_STATUSES = ["draft", "published", "unlisted", "archived"];

/** Status em que o evento e alcancavel publicamente por quem tem o link. */
export const PUBLIC_EVENT_STATUSES = ["published", "unlisted"];

/** Estados do tratamento da foto (Photo.Status / Photo.FaceStatus no backend). */
export const PHOTO_STATUSES = ["pending", "processing", "done", "failed"];

export const categoryLabel = (t, value) =>
  value ? t(`event.category.${value}`, value) : "";

/**
 * Rotulo do chip do evento: a MODALIDADE quando for esporte (Basquete, Vôlei…),
 * senao o tipo do evento (Formatura, Show…).
 */
export function eventChipLabel(t, event) {
  if (event?.category === "sports" && event?.sport_name) {
    return event.sport_name;
  }
  return categoryLabel(t, event?.category);
}

/** "10/07/2026" ou "10/07/2026 - 15/07/2026" no idioma ativo. */
export function formatEventDates(event, lang) {
  if (!event?.start_date) return "";
  const locale = lang === "pt-br" ? "pt-BR" : "en-US";
  const format = (value) =>
    new Date(`${value}T00:00:00`).toLocaleDateString(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const start = format(event.start_date);
  if (!event.end_date || event.end_date === event.start_date) return start;
  return `${start} - ${format(event.end_date)}`;
}

/** "Cidade, UF" a partir dos campos de local do evento. */
export function formatEventPlace(event) {
  return [event?.city, event?.state].filter(Boolean).join(", ");
}

/**
 * Rotulo do campeonato: "Copa Verão · 2026".
 *
 * A temporada e omitida quando o proprio nome ja a carrega — e comum cadastrar
 * "Campeonato Estadual U14 2026" com temporada "2026", e concatenar os dois
 * imprimiria o ano duas vezes.
 */
export function championshipLabel(championship) {
  if (!championship) return "";
  const { name = "", season = "" } = championship;
  if (!season || name.includes(season)) return name;
  return `${name} · ${season}`;
}

/**
 * Linha que descreve o evento: "Nome - Data - Campeonato - Local - Cidade".
 *
 * MESMO formato que o backend usa nas meta tags de compartilhamento
 * (`views/public.py: _event_description`) — as duas pontas descrevem a mesma
 * página, e ver textos diferentes conforme quem pede seria um defeito.
 * Campo vazio some da linha, sem deixar " - - " no meio.
 */
export function eventShareDescription(event, lang) {
  if (!event) return "";
  return [
    event.name,
    formatEventDates(event, lang),
    championshipLabel(event.championship),
    event.location_name,
    formatEventPlace(event),
  ]
    .filter(Boolean)
    .join(" - ");
}
